import * as React from "react"
import { getBrandThemeFromDomain } from "src/utils/brandTheme"

import { LogoSpinner } from "./logo-spinner"

export interface PageSuspenseProps {
  children: React.ReactNode
}

export const PageSuspense: React.FC<PageSuspenseProps> = ({ children }) => {
  return (
    <React.Suspense
      fallback={
        <div className="w-full h-screen flex items-center justify-center">
          <LogoSpinner className="text-slate-400" brandTheme={getBrandThemeFromDomain()} />
        </div>
      }
    >
      {children}
    </React.Suspense>
  )
}
